import React, { useState, useEffect } from 'react'
import axios from 'axios'

import Panel from '../ui/Panel'
import CoachesLangForm from './CoachesLangForm'
import { Notice, SkeletonForm, EmptyState } from './media'
import './media.css'

/*
 * COACHES' VIDEO — the languages.
 *
 * The twin of SponsorLang against the same GET admin/lang: one tab strip, one
 * form under it, and the child still receives LangID={item.UUID} — the value
 * the form has always posted. Only the active language is mounted, so opening
 * a record no longer fires one request per language at once.
 */

export default function CoachesVideosLang(props) {

  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [failed, setFailed] = useState('')
  const [active, setActive] = useState(null)

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadData = () => {
    setIsLoading(true)
    setFailed('')
    axios.get(process.env.REACT_APP_API_SERVER + 'admin/lang', {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {
        setData(res.data.results)
        setIsLoading(false)

      }).catch(err => {
        setIsLoading(false)
        setFailed('Δεν ήταν δυνατή η φόρτωση των γλωσσών.')
      })
  }

  const list = Array.isArray(data) ? data : []
  const current = list.find((item) => item.LangID === active) || list[0]

  return (
    <Panel
      title="Γλώσσες Βίντεο"
      subtitle={list.length > 0 ? list.length + ' γλώσσες περιεχομένου' : 'Τίτλος και περιγραφή ανά γλώσσα'}
    >
      {failed ? <Notice kind="crit" onClose={() => setFailed('')}>{failed}</Notice> : null}

      {isLoading ? <SkeletonForm rows={2} /> : null}

      {!isLoading && list.length === 0 && !failed ? (
        <EmptyState title="Καμία γλώσσα" hint="Δεν έχουν οριστεί γλώσσες περιεχομένου." />
      ) : null}

      {!isLoading && list.length > 0 ? (
        <>
          <div className="md-tabs" role="tablist" aria-label="Γλώσσες Βίντεο">
            {list.map((item) => (
              <button
                key={item.LangID}
                type="button"
                role="tab"
                className="md-tab"
                aria-selected={current && current.LangID === item.LangID}
                onClick={() => setActive(item.LangID)}
              >
                {item.LangName}
              </button>
            ))}
          </div>

          {current ? (
            <CoachesLangForm key={current.UUID} CoachVideoID={props.CoachVideoID} LangID={current.UUID} />
          ) : null}
        </>
      ) : null}
    </Panel>
  )
}
